import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { useQuery, UseQueryResult } from 'react-query';
import { ConsentContractRoot } from 'lib';

export const getQueryData = async (
    url: string,
    token: string
): Promise<AxiosResponse<ConsentContractRoot[], any>> => {
    const headers = getDefaultHeaders(token);
    const response = await axiosInstance().get(url, withHeaders(headers));
    return response.data;
};

export const useConsentContractList = (
    props: any
): UseQueryResult<ConsentContractRoot[], Error> => {
    const { getToken } = useAuth();
    const { chain, onLoadSuccess, onLoadError, enabled } = props;

    const url = `/graphchain/${chain}/query/consentcontracts`;

    return useQuery(
        [`consent-contracts-${chain}`],
        async () => getQueryData(url, getToken()),
        {
            ...getQueryData,
            onSuccess: onLoadSuccess,
            onError: onLoadError,
            enabled: enabled,
        }
    );
};
